import React from "react";

export const ChatAppConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/activity-management/collaboration",
      component: React.lazy(() => import("./ChatApp"))
    }
  ]
};
